import Http from '../http'

export const show = (id) => Http.get(`/company/order/log/${id}`, { headers: { Authorization: localStorage.token } })
